import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import type { z } from 'zod';
import { BatchModel, BatchesListModel } from '../_models/batch';
import { queryKeyMap } from '../_utils/query-keys';

export const useBatches = <U = z.infer<typeof BatchesListModel>>({
  params,
  select,
}: {
  params: {
    batchType: string | null;
    createdAtFrom: string | null;
    createdAtTo: string | null;
    page: string;
  };
  select?: (data: z.infer<typeof BatchesListModel>) => U;
}) => {
  return useQuery({
    // TODO: Differentiate cache for each batchType. ex) ['batch', batchType, restParams]
    queryKey: queryKeyMap.batch(params),
    queryFn: async () => {
      const batches = await axiosGet('/api/batch-results/', params);
      return BatchesListModel.parse(batches);
    },
    select,
  });
};

export const useBatch = (id: string) => {
  return useQuery({
    queryKey: ['batch', id],
    queryFn: async () => {
      const batch = await axiosGet(`/api/batch-results/${id}/`);
      return BatchModel.parse(batch);
    },
    enabled: !!id,
  });
};

export const useBatchFileJson = ({
  id,
  enabled = true,
}: {
  id: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ['batch-file-json', id],
    queryFn: async () => {
      const jsonData = await axiosGet(`/api/batch-results/${id}/json-data/`);
      return jsonData as any;
    },
    enabled: enabled && !!id,
  });
};
